import { Container } from "react-bootstrap"

const AICaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <h2 className="text-primary ft-wt-700 mb-4">Sentiment Analysis Based Recommendation System</h2>

                <h3 className="text-primary ft-wt-700 mb-3">The Challenge</h3>
                <p>
                    Today, the post-digital era customers have a louder voice than ever before and digital reviews play an important role in enhancing global communications among customers and influencing customer buying patterns. We can notice every business is trying to get in the habit of asking for customer reviews. These reviews help companies to understand their customer needs better and improve customer satisfaction by promoting quality products. Reviews and Feedback are worthless if we don't analyze and figure out what the true needs and problems of the customers are and/or don't actually act on it and use it actively and continuously to develop and drive the business forward. It is difficult to go through tons of reviews manually to act upon customer reviews/problems.
                </p>

                <h3 className="text-primary ft-wt-700 mb-3">The Solution</h3>
                <p>
                    Manually gathering information about user-generated data is time-consuming. By using this insightful information, we have developed an end-to-end “Recommendation System” based on “Sentiment Analysis of Product Reviews” using Machine Learning and Natural Language Processing.
                </p>
                <p className="ft-wt-700">Challenges:</p>
                <ul>
                    <li>Utilization of Big Data</li>
                    <li>Sarcasm: Sarcasm is a type of sentiment where people express their negative feelings using positive or intensified positive words in the text</li>
                    <li>Negation Detection: To detect negation effect on consumer reviews which look positive but are exactly negative in sense</li>
                </ul>

                <h3 className="text-primary ft-wt-700 mb-3">The Benefits</h3>
                <p>
                    This system can be used across different industries like E-commerce, Retail, Health care, and social media platforms. This helps companies gain a positive niche in customers’ expectations with more established competition in the market.
                </p>
                <p>Listed below are some of the benefits of how Sentiment-based automated solutions help companies.</p>
                <ul>
                    <li>Improve customer experience</li>
                    <li>Improve customer service by resolving issues quickly</li>
                    <li>Provide valuable insights and thus help organizations formulate effective business strategies and identify business opportunities.</li>
                    <li>Customer feedback/reviews are measurable and automatically turns that into sales by understanding consumer needs and preferences better.</li>
                </ul>
            </Container>

        </section>
    )
}

export default AICaseStudy